import restClient from "../restClient";

const endpoint = "/inventory-vehicle-statuses";

export const getStatuses = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(endpoint, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createStatus = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { 
        data: { 
            status_name: data.name, 
            status_key: data.key,
            color: data.color,
            is_active: data.is_active
        } 
    }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateStatus = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { 
        data: { 
            status_name: data.name, 
            status_key: data.key,
            color: data.color,
            is_active: data.is_active
        } 
    }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteStatus = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};